const actionTypes = {
    SIGN_IN: 'USER.SIGN_IN',
    UPDATE: 'USER.UPDATE',
    NOT_FOUND: 'USER.NOT_FOUND',
    DRAFT_STORE_DETAILS: 'DRAFT_STORE_DETAILS',
    DRAFT_ZIP_CODE: 'DRAFT_ZIP_CODE',
    CLEAR_UPPER_FUNNEL_DRAFT: 'CLEAR_UPPER_FUNNEL_DRAFT',
    STORE_CHANGED_FROM_HEADER: 'STORE_CHANGED_FROM_HEADER',
    UPDATE_SMS_STATUS: 'UPDATE_SMS_STATUS',
    ADD_SUBSCRIBED_EMAIL: 'ADD_SUBSCRIBED_EMAIL',
    UPDATE_BEAUTY_PREFERENCE: 'UPDATE_BEAUTY_PREFERENCE',
    TOGGLE_SELECT_AS_DEFAULT_PAYMENT: 'PAYMENT_GROUP_TOGGLE_SELECT_AS_DEFAULT_PAYMENT',
    UPDATE_SEGMENTS: 'UPDATE_SEGMENTS'
};

module.exports = actionTypes;
